import {
	LICENSED_PRODUCTS,
	getLicensedProducts,
	determineProductCrossSellConfig,
} from '@atlassian/jira-common-util-get-tenant-context';

type CriteriaResponse = {
	hasJiraSoftware: boolean;
	hasOpsgenie: boolean;
	hasJiraServiceManagement: boolean;
};

const getFeatureCriteria = (): CriteriaResponse => {
	const products = getLicensedProducts();
	const { JIRA_SOFTWARE, OPSGENIE, JIRA_SERVICEDESK } = LICENSED_PRODUCTS;

	const hasJiraSoftware = products[JIRA_SOFTWARE] || false;
	const hasJiraServiceManagement = products[JIRA_SERVICEDESK] || false;
	const hasOpsgenie = products[OPSGENIE] || false;

	return { hasJiraSoftware, hasOpsgenie, hasJiraServiceManagement };
};

// When false nav item disappears and content asks you to go to settings and connect a team
export const matchMegaphoneFeaturePreExpandCriteria = (): boolean => {
	try {
		const productSuggestionsEnabled = determineProductCrossSellConfig() === 'enabled';
		const { hasJiraSoftware, hasOpsgenie, hasJiraServiceManagement } = getFeatureCriteria();
		return (
			productSuggestionsEnabled && hasJiraSoftware && !hasOpsgenie && !hasJiraServiceManagement
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return false;
	}
};

export const matchMegaphoneFeaturePostExpandCriteria = (): boolean => {
	try {
		const { hasJiraSoftware, hasOpsgenie, hasJiraServiceManagement } = getFeatureCriteria();
		return hasJiraSoftware && (hasOpsgenie || hasJiraServiceManagement);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		return false;
	}
};
